<script>
  import CollapsedContainer from '@/components/Ecommerce/CollapsedContainer'

  export default {
    components: {
      CollapsedContainer
    },
    props: {
      title: {
        type: String,
        default: null
      },
      description: {
        type: String,
        default: null
      }
    }
  }
</script>

<template>
  <!-- Products without an EX-description otherwise rendered an empty heading
       plus an empty collapse block (EXAMS-138 QA, mobiel). -->
  <div v-if="description">
    <h4 class="sm:text-center mb-6">
      {{ title }}
    </h4>
    <CollapsedContainer>
      <!-- RichTextContent delegates relative CMS links to vue-router so the
           cross-links in product descriptions navigate correctly. -->
      <RichTextContent :content="description" />
    </CollapsedContainer>
  </div>
</template>
